// extracted by mini-css-extract-plugin
export var content = "gold-silver-module--content--ae2dd";
export var imgItem = "gold-silver-module--imgItem--38c8b";
export var imgWrapper = "gold-silver-module--imgWrapper--ef497";
export var infoText = "gold-silver-module--infoText--bf4d5";
export var infoTitle = "gold-silver-module--infoTitle--b05a0";
export var link = "gold-silver-module--link--1bb8d";
export var stores = "gold-silver-module--stores--9d499";